import styled from 'styled-components';
import colors from '../../styles/colors';

export const CallButton = styled.button`
  background: ${colors.primary};
  color: #fff;
  border: 1px solid ${colors.primary};
  margin: 0 10px;
  padding: 5px 10px;
  border-radius: 30px;
  font-size: 15px;
  width: 100px;
  position: absolute;
  right: 30px;
  top: 10px;
  text-align: center;
`;

export const CallLinkButton = styled.a`
  background: #00b900;
  color: #fff;
  border: 1px solid #00b900;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  text-decoration: auto;
  margin: 0 10px;
  padding: 5px 10px;
  border-radius: 30px;
`;
